import * as z from "zod";
import { versionDetailSchema } from "./common";

export const getVersion = {
  name: "getVersion" as const,
  input: z.object({ id: z.string(), version: z.number().int().positive() }),
  output: z.object({ version: versionDetailSchema }),
};
